import { createApi } from '@core/fetch'

export default {
  // 参考案例列表
  getConsultList: createApi(
    '/p/wedding/index.php/Admin/APISetMeal/ConsultCaseList'
  ),
  // 案例数是否大于 8 且 是否含有参考案例数
  getConsultCount: createApi(
    '/p/wedding/index.php/Admin/APISetMeal/ConsultCaseNum'
  ),
  // 删除参考案例
  deleteConsultCase: createApi.post(
    '/p/wedding/index.php/Admin/APISetMeal/DelConsultCase'
  )
}
